import { gql } from "@apollo/client";
export default gql`
  mutation invalidateImmediately {
    invalidateImmediately {
      message
    }
  }
`;
